import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { REVERT_CHANGE } from 'store/mutations';
import AgentPortalError from 'errors/AgentPortalError';
import { ACTION_CODES } from 'constants/errors';
import { CancelButton } from 'components/ui/Button';
import styled from 'styled-components';

export const StyledButton = styled(CancelButton)`
  white-space: nowrap;
`;

const RevertChangeCta = ({ history, bookingReference, nextRoute }) => {
  const [revertChange, { error, loading }] = useMutation(REVERT_CHANGE, {
    variables: { bookingReference },
    update: () => {
      history.push(nextRoute);
    }
  });

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: nextRoute
    });
  }

  return (
    <StyledButton id="revert-change-cta" disabled={loading} loading={loading} onClick={revertChange}>
      <FormattedMessage id="manageBooking.abandonCancellation" />
    </StyledButton>
  );
};

RevertChangeCta.propTypes = {
  nextRoute: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  bookingReference: PropTypes.string.isRequired
};

export default RevertChangeCta;
